export default "__VITE_ASSET__BXeBxFwr__"